import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles/profile.css';

/**
 * Componente de perfil de usuario para depuración
 * Muestra información detallada sobre el usuario actual y su estado de autenticación
 */
const UserProfileDebug = () => {
  const { user, isAuthenticated, hasRole } = useAuth();
  const [authStatus, setAuthStatus] = useState({
    isAuthenticated: false,
    hasUserRole: false,
    hasParentRole: false,
    hasCoachRole: false,
    hasAdminRole: false,
  });

  useEffect(() => {
    // Verificar el estado de autenticación y roles
    setAuthStatus({
      isAuthenticated: isAuthenticated(),
      hasUserRole: hasRole('user'),
      hasParentRole: hasRole('parent'),
      hasCoachRole: hasRole('coach'),
      hasAdminRole: hasRole('admin'),
    });
  }, [isAuthenticated, hasRole]);

  if (!user) {
    return (
      <div className="profile-section">
        <div className="container">
          <div className="profile-header">
            <h1>Error: Usuario no encontrado</h1>
            <p>No se ha podido cargar la información del usuario.</p>
            <p>
              Estado de autenticación:{' '}
              {authStatus.isAuthenticated ? 'Autenticado' : 'No autenticado'}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-section">
      <div className="container">
        <div className="profile-header">
          <div className="profile-avatar">
            <img src={user.avatar || '/img/default-avatar.svg'} alt={user.name} />
          </div>

          <div className="profile-info">
            <h1>{user.name}</h1>
            <div className="profile-meta">
              <div className="profile-meta-item">
                <span className="material-icons">email</span>
                <span>{user.email}</span>
              </div>
              <div className="profile-meta-item">
                <span className="material-icons">badge</span>
                <span>{user.role || 'Sin rol'}</span>
              </div>
            </div>

            <div className="profile-stats">
              <div className="profile-stat">
                <div className="stat-value">{user.xpPoints || 0}</div>
                <div className="stat-label">Puntos XP</div>
              </div>
              <div className="profile-stat">
                <div className="stat-value">€{user.walletBalance || 0}</div>
                <div className="stat-label">Monedero</div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="debug-info"
          style={{
            backgroundColor: '#f8f9fa',
            padding: '20px',
            borderRadius: '10px',
            marginTop: '20px',
          }}
        >
          <h2>Información de Depuración</h2>

          <h3>Estado de Autenticación</h3>
          <ul>
            <li>isAuthenticated: {authStatus.isAuthenticated ? '✅ Sí' : '❌ No'}</li>
            <li>Rol &apos;user&apos;: {authStatus.hasUserRole ? '✅ Sí' : '❌ No'}</li>
            <li>Rol &apos;parent&apos;: {authStatus.hasParentRole ? '✅ Sí' : '❌ No'}</li>
            <li>Rol &apos;coach&apos;: {authStatus.hasCoachRole ? '✅ Sí' : '❌ No'}</li>
            <li>Rol &apos;admin&apos;: {authStatus.hasAdminRole ? '✅ Sí' : '❌ No'}</li>
          </ul>

          <h3>Datos del Usuario</h3>
          <pre
            style={{
              backgroundColor: '#e9ecef',
              padding: '15px',
              borderRadius: '5px',
              overflow: 'auto',
            }}
          >
            {JSON.stringify(user, null, 2)}
          </pre>
        </div>
      </div>
    </div>
  );
};

export default UserProfileDebug;
